import Contrato from './componentes/Contrato.vue';
import ContratoLista from './componentes/Lista.vue';
import ContratoRelatorio from './componentes/Relatorio.vue';
import ContratoRelatorioLiberados from './componentes/RelatorioLiberados.vue';
import ContratoLiberados from './componentes/ContratoLiberados.vue';

export default {
  path: '/contrato',
  component: Contrato,
  meta: { auth: true },
  children: [
    {
      path: ':tipo',
      component: ContratoLista,
      name: 'contrato',
    },
    {
      path: ':id/relatorio',
      component: ContratoRelatorio,
      name: 'contrato.relatorio'
    },
    {
      path: '',
      component: ContratoLiberados,
      name: 'contrato.liberados',
    },
    {
      path: ':id/relatorio/liberados',
      component: ContratoRelatorioLiberados,
      name: 'contrato.relatorio-liberados'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/contrato/rotas.js